import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import QueueAnim from "rc-queue-anim";
import { tryNow } from "../../utils";

export const MainBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="banner">
      <div className="inner">
        <div className="content">
          <QueueAnim type="left" delay={300} duration={2000}>
            <div key="1" className="slogn">
              {t("page.banner.title")}
            </div>
            <div key="2" className="descrption">
              {t("page.banner.subtitle")}
            </div>
            <div key="3" className="button" onClick={tryNow}>
              {t("common.button.try-now")}
            </div>
          </QueueAnim>
        </div>
        <div className="bg">
          <img
            src={"//files.authing.co/authing-website/home-banner-new.png"}
            alt="authing banner background"
          />
        </div>
      </div>
    </div>
  );
};
